import axios from "axios";
import { API_URL } from "../../const";

/** ***************** ADD DEPARTMENT DETAILS START *********************** */
export const departmentDetailsAdd = (addData: JSON) => {
  const data = {
    CreateDepartmentToken: addData,
  };
  const url = `${API_URL}CreateDepartment`;
  return axios.post(url, data, {
    headers: { "Content-type": "application/json" },
  });
};
/** ***************** ADD DEPARTMENT DETAILS END *********************** */

/** ***************** UPDATE DEPARTMENT DETAILS START *********************** */
export const departmentDetailsUpdate = (updateData: JSON) => {
  const data = {
    UpdateDepartmentToken: updateData,
  };
  const url = `${API_URL}UpdateDepartment`;
  return axios.post(url, data, {
    headers: { "Content-type": "application/json" },
  });
};
/** ***************** UPDATE DEPARTMENT DETAILS END *********************** */

/** ***************** GET DEPARTMENT DETAILS START *********************** */
export const departmentListGet = (listData: any) => {
  const data = {
    GetDepartmentToken: listData,
  };
  const url = `${API_URL}FetchDepartmentDetails`;
  return axios.post(url, data, {
    headers: { "Content-type": "application/json" },
  });
};
/** ***************** GET DEPARTMENT DETAILS END *********************** */

/** ***************** FETCH DEPARTMENT DETAILS START *********************** */
export const departmentGetData = (fetchData: any) => {
  const data = {
    GetDepartmentToken: fetchData,
  };
  const url = `${API_URL}FetchDepartmentDetails`;
  return axios.post(url, data, {
    headers: { "Content-type": "application/json" },
  });
};
/** ***************** FETCH DEPARTMENT DETAILS END *********************** */

/** ***************** DELETE DEPARTMENT DETAILS START *********************** */
export const departmentDetailsDelete = (deleteData: any) => {
  const data = {
    DeleteDepartmentToken: deleteData,
  };
  const url = `${API_URL}DeleteDepartment`;
  return axios.post(url, data, {
    headers: { "Content-type": "application/json" },
  });
};
/** ***************** DELETE DEPARTMENT DETAILS END *********************** */

/** ***************** GET DEPARTMENT DETAILS START *********************** */
export const departmentListForAll = (listData: any) => {
  const data = {
    GetAllDepartmentPaginationToken: listData,
  };
  const url = `${API_URL}GetAllDepartmentDetailsPagination`;
  return axios.post(url, data, {
    headers: { "Content-type": "application/json" },
  });
};
/** ***************** GET DEPARTMENT DETAILS END *********************** */
